export const BYPASS_UTM = 'bypass_utm';
export const ORGANIC_SEARCH = 'organic_search';
export const ORGANIC_SOCIAL = 'organic_social';
export const ORGANIC_VIDEO = 'organic_video';
export const REFERRAL = 'referral';
export const UTM_MEDIUM_DEFAULT = 'direct';
export const UTM_SOURCE_DEFAULT = 'none';
export const GOOGLE_URL = 'google.com';
export const UTM_MEDIUM = 'utm_medium';
export const UTM_SOURCE = 'utm_source';

export const SEARCH_SITE_LIST = [
  '360',
  'alice',
  'aol',
  'ask',
  'auone',
  'avg',
  'babylon',
  'baidu',
  'biglobe',
  'bing',
  'centrum',
  'cnn',
  'comcast',
  'conduit',
  'daum',
  'daum',
  'dogpile',
  'duckduckgo',
  'ecosia',
  'seznam',
  'eniro',
  'exalead',
  'excite',
  'firmy',
  'globo',
  'mail',
  'google',
  'google-play',
  'googlemybusiness',
  'incredimail',
  'kvasir',
  'lycos',
  'msn',
  'najdi',
  'naver',
  'onet',
  'qwant',
  'rakuten',
  'rambler',
  'search-results',
  'aol',
  'docomo',
  'so',
  'sogou',
  'startsiden',
  'terra',
  'tut',
  'ukr',
  'virgilio',
  'yahoo',
  'yandex'
];

export const ORGANIC_SITE_LIST = [
  '43things',
  '51',
  '5ch',
  'hatena',
  'imageshack',
  'academia',
  'activerain',
  'activeworlds',
  'addthis',
  'airg',
  'allnurses',
  'allrecipes',
  'alumniclass',
  'ameba',
  'ameblo',
  'americantowns',
  'reddit',
  'ancestry',
  'anobii',
  'answerbag',
  'aolanswers',
  'facebook',
  'pinterest',
  'artstation',
  'askubuntu',
  'asmallworld',
  'athlinks',
  'away',
  'awe',
  'baby-gaga',
  'babyblog',
  'badoo',
  'bebo',
  'beforeitsnews',
  'bharatstudent',
  'biip',
  'biswap',
  'bit',
  'blackcareernetwork',
  'blackplanet',
  'blip',
  'blog',
  'goo',
  'blogg',
  'bloggang',
  'blogger',
  'blogher',
  'bloglines',
  'blogs',
  'blogsome',
  'blogspot',
  'blogster',
  'blurtit',
  'brightkite',
  'brizzly',
  'buzzfeed',
  'buzznet',
  'cafemom',
  'camospace',
  'canalblog',
  'care',
  'care2',
  'caringbridge',
  'catster',
  'cbnt',
  'cellufun',
  'centerblog',
  'zalo',
  'chegg',
  'chicagonow',
  'classmates',
  'classquest',
  'cocolog-nifty',
  'linternaute',
  'couchsurfing',
  'cozycot',
  'cross',
  'crunchyroll',
  'cyworld',
  'dailystrength',
  'deluxe',
  'deviantart',
  'dianping',
  'digg',
  'diigo',
  'hubpages',
  'disqus',
  'dogster',
  'dol2day',
  'doostang',
  'dopplr',
  'douban',
  'draugiem',
  'drugs-forum',
  'dzone',
  'edublogs',
  'elftown',
  'epicurious',
  'everforo',
  'exblog',
  'extole',
  'faceparty',
  'fandom',
  'fanpop',
  'fark',
  'fb',
  'fc2',
  'feedspot',
  'feministing',
  'filmaffinity',
  'flickr',
  'flipboard',
  'folkdirect',
  'foodservice',
  'androidcentral',
  'crackberry',
  'imore',
  'nexopia',
  'webosnation',
  'wpcentral',
  'fotki',
  'fotolog',
  'foursquare',
  'friendfeed',
  'fruehstueckstreff',
  'fubar',
  'gaiaonline',
  'gamerdna',
  'gather',
  'geni',
  'getpocket',
  'glassboard',
  'glassdoor',
  'godtube',
  'goldenline',
  'goldstar',
  'gooblog',
  'goodreads',
  'govloop',
  'gowalla',
  'gree',
  'gulli',
  'gutefrage',
  'habbo',
  'hi5',
  'hootsuite',
  'houzz',
  'hoverspot',
  'hr',
  'hubculture',
  'hyves',
  'ibibo',
  'identi',
  'ig',
  'imvu',
  'insanejournal',
  'instagram',
  'instapaper',
  'internations',
  'interpals',
  'intherooms',
  'irc-galleria',
  'is',
  'italki',
  'jammerdirect',
  'jappy',
  'kaboodle',
  'kakao',
  'kakaocorp',
  'kaneva',
  'messenger',
  'last',
  'librarything',
  'line',
  'linkedin',
  'listal',
  'listography',
  'livedoor',
  'livedoorblog',
  'livejournal',
  'lnkd',
  'vk',
  'yelp',
  'mbga',
  'medium',
  'meetin',
  'meetup',
  'meinvz',
  'meneame',
  'menuism',
  'mix',
  'mixi',
  'mocospace',
  'mouthshut',
  'movabletype',
  'mubi',
  'opera',
  'myanimelist',
  'myheritage',
  'mylife',
  'mymodernmet',
  'myspace',
  'netvibes',
  'ycombinator',
  'newsshowcase',
  'ngopost',
  'niconico',
  'nicovideo',
  'nightlifelink',
  'ning',
  'odnoklassniki',
  'okwave',
  'oneworldgroup',
  'onstartups',
  'opendiary',
  'over-blog',
  'overblog',
  'paper',
  'partyflock',
  'photobucket',
  'pinboard',
  'pingsta',
  'pixiv',
  'playahead',
  'plurk',
  'plurk',
  'pocket',
  'posterous',
  'homeadvisor',
  'qapacity',
  'quechup',
  'quora',
  'qq',
  'ravelry',
  'redux',
  'renren',
  'researchgate',
  'reunion',
  'reverbnation',
  'rtl',
  'ryze',
  'salespider',
  'scoop',
  'screenrant',
  'scribd',
  'scvngr',
  'secondlife',
  'serverfault',
  'shareit',
  'sharethis',
  'shvoong',
  'skype',
  'skyrock',
  'slashdot',
  'slideshare',
  'smartnews',
  'snapchat',
  'sociallife',
  'socialvibe',
  'live',
  'spoke',
  'spruz',
  'ssense',
  'stackapps',
  'stackexchange',
  'stackoverflow',
  'stardoll',
  'stickam',
  'studivz',
  'suomi24',
  'superuser',
  'sweeva',
  't',
  'tagged',
  'taggedmail',
  'talkbiznow',
  'taringa',
  'techmeme',
  'tencent',
  'tiktok',
  'tinyurl',
  'toolbox',
  'travellerspoint',
  'tripadvisor',
  'trombi',
  'tudou',
  'tuenti',
  'tumblr',
  'tweetdeck',
  'twitter',
  'twoo',
  'typepad',
  'unblog',
  'urbanspoon',
  'ushareit',
  'ushi',
  'vampirefreaks',
  'vampirerave',
  'vg',
  'ibm',
  'vkontakte',
  'wakoopa',
  'wattpad',
  'webshots',
  'wechat',
  'weebly',
  'weibo',
  'wer-weiss-was',
  'weread',
  'whatsapp',
  'answers',
  'wikihow',
  'wikitravel',
  'woot',
  'wordpress',
  'xanga',
  'xing',
  'yahoo-mbga',
  'yammer',
  'youroom',
  'zoo',
  'zooppa'
];

export const VIDEO_SITE_LIST = [
  'twitch',
  'crackle',
  'curiositystream',
  'd.tube',
  'dailymotion',
  'disneyplus',
  'wistia',
  'hulu',
  'netflix',
  'iq',
  'iqiyi',
  'justin',
  'youtube',
  'vimeo',
  'ted',
  'utreon',
  'veoh',
  'journaldunet',
  'youku',
  'youku'
];

export const PRODUCTS = {
  ACADEMY_PAGE: 'academy_homepage',
  BTL_PAGE: 'btl_page',
  COURSES_PAGE: 'courses',
  CRT_PAGE: 'career_roadmap_tool',
  DATASCIENCE_PAGE: 'data_science_homepage',
  DEVOPS_PAGE: 'devops_homepage',
  EVENT_PAGE: 'event',
  EVENTS_PAGE: 'events',
  HOME_PAGE: 'homepage',
  MEETINGS_PAGE: 'meetings',
  MENTEE_DASHBOARD_PAGE: 'learner_dashboard',
  NEOVARSITY_PAGE: 'neovarsity_homepage',
  RESUME_CONSULTATION_PAGE: 'resume_consultation_page',
  REVIEW_PAGE: 'review_homepage',
  TEST_PAGE: 'scaler_enrolment'
};

export const COOKIE_KEY = 'gtm_data';
export const GTM_ID = 'GTM-M94JJN9';
